(() => {
  if (customElements.get('mt-product-video')) return;
  class ModTimeProductVideo extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.videos = Array.from(this.querySelectorAll('video'));
      this.visible = new Set();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      // Scoped convenience deterrents only: no network or screen-capture protection.
      this.querySelectorAll('.mt-pv__tile').forEach(tile => {
        tile.addEventListener('contextmenu', event => event.preventDefault(), options);
        tile.addEventListener('dragstart', event => event.preventDefault(), options);
      });
      this.videos.forEach(video => {
        video.muted = true;
        video.defaultMuted = true;
        video.controls = false;
        video.disablePictureInPicture = true;
        video.disableRemotePlayback = true;
        video.addEventListener('error', () => {
          video.pause();
          video.dataset.failed = 'true';
          video.removeAttribute('src');
          video.load(); // Return to the poster on network/decode failure.
        }, options);
      });
      this.sync = () => {
        const suppress = document.hidden || this.reduced.matches || this.connection?.saveData;
        this.videos.forEach(video => {
          if (suppress || !this.visible.has(video) || video.dataset.failed) {
            video.pause();
            return;
          }
          if (!video.getAttribute('src')) video.src = video.dataset.src;
          video.muted = true;
          video.play().catch(() => {}); // Keep poster/frame if browser blocks autoplay.
        });
      };
      this.reduced.addEventListener('change', this.sync, options);
      this.connection?.addEventListener('change', this.sync, options);
      document.addEventListener('visibilitychange', this.sync, options);
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) this.visible.add(entry.target);
          else this.visible.delete(entry.target);
        });
        this.sync();
      }, { threshold: .2 });
      this.videos.forEach(video => this.observer.observe(video));
    }
    disconnectedCallback() {
      this.videos?.forEach(video => video.pause());
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
  }
  customElements.define('mt-product-video', ModTimeProductVideo);
})();
